import React from 'react';
import { ProcessTimeline } from '../process/ProcessTimeline';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
export function ProcessPreview() {
  return <section className="bg-midnight-800 py-24 md:py-32" data-id="element-265" data-mp="3fty0ekzgp7jb">
      <div className="container-page" data-id="element-266" data-mp="3fvheq61k58ig">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-267" data-mp="3krfzljnog8e4">
          <SectionHeading tone="dark" kicker="Our process" title="Ten stages, one accountable consultant." intro="A structured methodology from first briefing to post-appointment follow-up, so every decision is informed." data-id="element-268" data-mp="cbw9uum7t83t" />
          <Button to="/process" variant="outlineLight" arrow className="self-start md:self-auto" data-id="element-269" data-mp="7lpmey3fvtn5">
            See the full process
          </Button>
        </div>
        <div className="mt-14" data-id="element-270" data-mp="v9z3xntmdv8h">
          <ProcessTimeline variant="compact" tone="dark" data-id="element-271" data-mp="1020dh1zel7ut" />
        </div>
      </div>
    </section>;
}